<template>
    <div id="entire_app__booking_details">
        <form>

            <div class="field_row travel_places">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="80" viewBox="0 0 30 108">
                    <g id="Group_39" data-name="Group 39" transform="translate(-684 -374)">
                        <g id="Ellipse_36" data-name="Ellipse 36" transform="translate(692 379)" fill="none" stroke="rgba(72,127,255,0.61)" stroke-width="3">
                            <circle cx="7.5" cy="7.5" r="7.5" stroke="none"/>
                            <circle cx="7.5" cy="7.5" r="6" fill="none"/>
                        </g>
                        <g id="Ellipse_46" data-name="Ellipse 46" transform="translate(687 374)" fill="none" stroke="rgba(72,127,255,0.61)" stroke-width="3">
                            <circle cx="12.5" cy="12.5" r="12.5" stroke="none"/>
                            <circle cx="12.5" cy="12.5" r="11" fill="none"/>
                        </g>
                        <g id="map-pin-line" transform="translate(684 452)">
                            <path id="Path_79" data-name="Path 79" d="M0,0H30V30H0Z" fill="none"/>
                            <path id="Path_80" data-name="Path 80" d="M15,26.119,21.6,19.8a8.665,8.665,0,0,0,0-12.633,9.632,9.632,0,0,0-13.2,0A8.665,8.665,0,0,0,8.4,19.8Zm0,3.609L6.515,21.607a11.14,11.14,0,0,1,0-16.243,12.384,12.384,0,0,1,16.971,0,11.14,11.14,0,0,1,0,16.243Zm0-13.69a2.555,2.555,0,1,0-2.667-2.552A2.611,2.611,0,0,0,15,16.038Zm0,2.552a5.223,5.223,0,0,1-5.333-5.1A5.223,5.223,0,0,1,15,8.381a5.223,5.223,0,0,1,5.333,5.1A5.223,5.223,0,0,1,15,18.59Z" transform="translate(0 0)" fill="rgba(72,127,255,0.59)"/>
                        </g>
                        <line id="Line_22" data-name="Line 22" y2="50" transform="translate(699.5 399.5)" fill="none" stroke="rgba(72,127,255,0.61)" stroke-width="3" stroke-dasharray="10"/>
                    </g>
                </svg>

                <input type="text" :value="$store.state.Booking.currentTicket.source" class="first_input" id="departure" name="departure" placeholder="Enter departure" readonly required>
                <input type="text" :value="$store.state.Booking.currentTicket.destination" id="destination" name="destination" placeholder="Enter destination" readonly required>
            </div>

            <div class="field_row bus_company">
                <svg id="bus-line" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path id="Path_171" data-name="Path 171" d="M0,0H24V24H0Z" fill="none"/>
                    <path id="Path_172" data-name="Path 172" d="M17,20H7v1a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V20H3V12H2V8H3V5A2,2,0,0,1,5,3H19a2,2,0,0,1,2,2V8h1v4H21v8H20v1a1,1,0,0,1-1,1H18a1,1,0,0,1-1-1Zm2-8V5H5v7Zm0,2H5v4H19ZM6,15h4v2H6Zm8,0h4v2H14Z" fill="#90b3ff"/>
                </svg>

                <label for="bus_company">Bus company</label>
                <select name="bus_company" id="bus_company" readonly>
                    <option :value="$store.state.Booking.currentTicket.companyname">{{ $store.state.Booking.currentTicket.companyname }}</option>
                </select>
            </div>

            <div class="field_row date_time">
                <svg id="calendar" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path id="Path_165" data-name="Path 165" d="M0,0H24V24H0Z" fill="none"/>
                    <path id="Path_166" data-name="Path 166" d="M17,3h4a1,1,0,0,1,1,1V20a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4A1,1,0,0,1,3,3H7V1H9V3h6V1h2Zm3,8H4v8H20ZM15,5H9V7H7V5H4V9H20V5H17V7H15ZM6,13H8v2H6Zm5,0h2v2H11Zm5,0h2v2H16Z" fill="rgba(72,127,255,0.64)"/>
                </svg>

                <svg id="timeline" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path id="Path_167" data-name="Path 167" d="M0,0H24V24H0Z" fill="none"/>
                    <path id="Path_168" data-name="Path 168" d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Zm0-2a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm1-8h4v2H11V7h2Z" fill="#88acff"/>
                </svg>

                <input type="date" id="date" name="date" :value="date" required readonly>
                <input type="text" name="time" :value="$store.state.Booking.currentTicket.starttime+' Hrs'" id="deptTime" placeholder="Time" required readonly>
                
            </div>

            <div class="field_row passenger">
                <svg id="user-3-line" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path id="Path_169" data-name="Path 169" d="M0,0H24V24H0Z" fill="none"/>
                    <path id="Path_170" data-name="Path 170" d="M20,22H18V20a3,3,0,0,0-3-3H9a3,3,0,0,0-3,3v2H4V20a5,5,0,0,1,5-5h6a5,5,0,0,1,5,5Zm-8-9a6,6,0,1,1,6-6A6,6,0,0,1,12,13Zm0-2A4,4,0,1,0,8,7,4,4,0,0,0,12,11Z" fill="#88acff"/>
                </svg>

                <label for="passenger">Passenger name</label>
                <input type="text" name="passenger" :value="$store.state.UserDetails.user.firstname+' '+$store.state.UserDetails.user.lastname" id="passenger" placeholder="Abiseth Gee" readonly required>
            </div>

            <div class="field_row passenger">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path fill="none" d="M0 0h24v24H0z"/><path d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 8H4v8h16v-8zm0-2V5H4v4h16zm-6 6h4v2h-4v-2z" fill="rgba(53,166,242,1)"/></svg>
                <label for="price">Ticket price</label>
                <input type="text" name="price" :value="'RWF '+ $store.state.Booking.currentTicket.price" id="price" placeholder="Price" readonly required>
            </div>

            <div class="field_row btn_book_section">
                <button @click.prevent="$store.commit('Booking/startBooking')" class="cancel">Cancel booking</button>
                <button @click.prevent="$store.commit('Booking/bookTicket', ticketdetails)" class="continue">
                    <span v-if="$store.state.Booking.hasSubmitted" class="spinner-border spinner-border-sm mr-1"></span>
                    <span v-if="!$store.state.Booking.hasSubmitted">Continue booking</span>
                </button>
            </div>

        </form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import formatDateMixin from '../../../mixins/formatDateMixins'

    export default {
        name: 'BookingDetails',
        components: {},
    
        props: {
            // ticketId: {
            //     type: String,
            //     required: true,
            //     default: null
            // }
        },

        data() {
            return {
                ticketdetails: {
                    'departure': '',
                    'destination': '',
                    'companyname': '',
                    'departdate': '',
                    'departtime': '',
                    'ticketowner': '',
                    'ticketPrice': 0,
                    'carplatenumber': ''
                },
                date: ''
            }
        },

        mixins: [formatDateMixin],        	
		computed: {
			...mapGetters({
				currentTicket: 'Booking/currentTicket'
			}),
            
        },
		mounted() {
            // this.$store.commit('Booking/getCurrentTicket', this.ticketId);    
		},

        updated() {
            this.getticket();                   
        },

        methods: {
            getdate(date) {
                var date_formated = date.split('T')[0];
                return this.date = date_formated;
            },

            getticket() {
                
                this.ticketdetails.departure = this.$store.state.Booking.source;
                this.ticketdetails.destination = this.$store.state.Booking.destination;
                this.ticketdetails.companyname = this.$store.state.Booking.companyname;
                this.ticketdetails.departtime = this.$store.state.Booking.starttime;
                this.ticketdetails.departdate = this.$store.state.Booking.currentTicket.date;
                this.ticketdetails.carplatenumber = this.$store.state.Booking.currentTicket.busplatenumber;
                this.ticketdetails.ticketowner = this.$store.state.UserDetails.user.firstname+ ' ' + this.$store.state.UserDetails.user.lastname;

                if (this.ticketdetails.departdate != undefined) {
                    this.getdate(this.ticketdetails.departdate);
                }

            }
        }

        
    }     
   
</script>

<style lang="scss" scoped>
    #entire_app__booking_details {
        width: 98%;
        height: 100%;

        form {
            margin-top: 4%;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            font-family:satoshi, $poppins;
            font-weight: 300;
            text-transform: capitalize;

            .btn_book_section {
                margin-top: 1em;
                display: flex;
                justify-content: space-between;
            }

            .travel_places {
                position: relative;
                height: 20%;
                margin-bottom: 0.8em;

                svg {
                    position: absolute;
                    top: 10%;
                    left: 3.5%;
                    height: 78%;
                }

                .first_input {
                    margin-bottom: 3%;
                }
            }

            .passenger {
                position: relative;
                
                svg {
                    position: absolute;
                    top: 55%;
                    left: 3.5%;
                }
            }

            .date_time {
                display: flex;
                justify-content: space-between;
                position: relative;

                #calendar {
                    position: absolute;
                    right: 54%;
                    top: 30%;
                }

                #timeline {
                    position: absolute;
                    right: 3%;
                    top: 30%;
                }

                input, select {
                    width: 49.4% !important;
                    font-size: 0.88em !important;
                    padding-left: 4% !important;
                    text-transform: capitalize !important;
                }

                select {
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    text-indent: 1px;
                    text-overflow: '';
                }

                input[type="date"]::-webkit-inner-spin-button,
                input[type="date"]::-webkit-calendar-picker-indicator {
                    opacity: 0;
                    margin-right: 0.8em;
                    z-index: 99;
                }

            }

            .bus_company {
                margin-top: 0.6em;
                position: relative;
                
                svg {
                    position: absolute;
                    top: 53%;
                    left: 4%;
                }

                select {
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    text-indent: 1px;
                    text-overflow: '';
                    font-size: 0.88em;

                    option {
                        font-size: 0.88em;
                        height: 2em;
                        padding-left: 0 !important;
                    }
                }

            }
                
            .field_row {
                width: 100%;
                margin-bottom: 0.8em;

                label {
                    width: 100%;
                    font-size: 0.8em;
                    color: $mainDark !important;
                }

                input, select {
                    width: 100%;
                    padding: 2.2% 0 2.2% 12%;
                    border-radius: 0.3em;
                    background-color: $bookingInputs;
                    outline: none;
                    font-size: 0.88em;
                    border: 0.11em solid $dimerBlue;
                    text-transform: capitalize;
                }
                
                input::placeholder {
                    font-size: 0.98em;
                    font-weight: 300 !important;
                }

                select {
                    width: 100%;
                }

                button {
                    width: 49.5%;
                    padding: 0.9em 0.8em;
                    font-size: 0.85em;
                    border: none;
                    border-radius: 0.25em;
                    outline: none;
                }

                .continue {
                    background-color: $ticketNavigation;
                    color: $pureWhite;
                }


            }
        }
    }
</style>